import { createContext, useContext, useEffect, useReducer, useState } from "react";
import { ActivitiesByIdsPayload, activitiesStatus, ActivitySection, DetailInformPayload, initialState, LogbookActionEnum, LogbookContextType, LogbookLoadings, SearchUserPayload, TabsItem, useDestinationsFilter, useListTabDefault, useListUserFilter, useOneUserFilter, UserMapListPayload, useUserFilter, } from "../utils";
import { reducer } from "../utils/reducers";
import { getArea, getDepartments, getDivisions, getRoles, getStore, getUsers, getUserTypes } from "../../../../../utils/methods/geServiceWithItemsFormat";
import { Item, ObjectGeneric } from "../../../../../utils/types/generals";
import { loogbookServiceFetch, userServiceFetch } from "../../../../../utils/constants/callService";
import { SelectUserPayload, UserItem } from "../components/shared/formActivity/selectUsersToAssign/types";
import { statusService } from "../../../../../service";
import { useNavigate } from "react-router-dom";
import { getPreviousYears, monthYear } from "../../../../../utils/constants/date_month";
import { UserMarkMap } from "../components/shared/map/types";
import { CodeDetasilInbform, UrlDetasilInbform } from "../../../../../service/logbook/response";
import { downloadBlob } from "../../../../../utils/methods/downloadFiles";
import { getUserRole } from "../../../../../service/auth";
import { Roles } from "../../../../../utils/enums";
import { UserSection } from "../utils/enums/userSection";

export const LogbookContext = createContext<LogbookContextType>(Object({}))
export const useLogbookContext = () => useContext(LogbookContext)
export const LoogbookContextProvider = ({ children }: { children: JSX.Element }) => {
    const navigate = useNavigate();
    const listTab = useListTabDefault()
    const [state, dispatch] = useReducer(reducer, initialState)
    const [visibleUsersData, setVisibleUsersData] = useState<Record<string, UserMarkMap>>({});
    const [visibleUsersDataGeneralList, setVisibleUsersDataGeneralList] = useState<Record<string, UserMarkMap>>({});
    const [visibleUsersDataByUser, setVisibleUsersDataByUser] = useState<Record<string, UserMarkMap>>({});
    const [hiddenLocalConstant, setHiddenLocalConstant] = useState<string[]>([])
    const [items, setItems] = useState<Record<string, Item[]>>()
    const filterUser = useUserFilter({ items })
    const filterOneUser = useOneUserFilter({ items })
    const filterMyActivity = useOneUserFilter({ items })
    const filterListUser = useListUserFilter({ items })
    const filterDestinations = useDestinationsFilter({ items })
    const changeTab = ({ value }: { value: TabsItem }) => {
        dispatch({ type: LogbookActionEnum.CHANGE_TAB, payload: { value } })
        dispatch({ type: LogbookActionEnum.ACTIVITY_SECTION, payload: { value: ActivitySection.USER_LIST } })
        if ((window.location.href.includes('?') || window.location.href.includes('#'))) {
            navigate(window.location.pathname, { replace: true });
        }
    }
    const changeActivitySection = ({ value }: { value: ActivitySection }) => {
        dispatch({ type: LogbookActionEnum.ACTIVITY_SECTION, payload: { value } })
    }
    const selectUserToActivities = ({ id }: { id: string }) => {

    }

    const getStatusItem = async () => {
        if (items?.status?.length) { return }
        const item = (await statusService().statusList()).filter(status => activitiesStatus.includes(status.id))
        setItems(prev => ({ ...prev, status: item.map(item => ({ value: item.id, id: item.id.toString(), label: item.description })) }))
    }
    const getStoreItem = async () => {
        if (items?.stores?.length) { return }
        const { items: item } = await getStore()
        setItems(prev => ({ ...prev, stores: item }))
    }
    const getRoleItem = async () => {
        if (items?.role?.length) { return }
        const { items: item } = await getRoles({ skip: [Roles.ADMIN] })
        setItems(prev => ({ ...prev, role: item }))
    }
    const getDivisionItem = async () => {
        if (items?.division?.length) { return }
        const { items: item } = await getDivisions()
        setItems(prev => ({ ...prev, division: item }))
    }
    const getUserTypeItem = async () => {
        if (items?.userType?.length) { return }
        const { items: item } = await getUserTypes()
        setItems(prev => ({ ...prev, userType: item }))
    }
    const getUsersItem = async () => {
        if (items?.user?.length) { return }
        const { items: item } = await getUsers({ addUserLogged: true })
        setItems(prev => ({ ...prev, user: item }))
    }
    const getAreaItem = async () => {
        if (items?.area?.length) { return }
        const item = await getArea()
        setItems(prev => ({ ...prev, area: item }))
    }
    const getDepartmentItem = async () => {
        if (items?.department?.length) { return }
        const item = await getDepartments()
        setItems(prev => ({ ...prev, department: item }))
    }
    const searchUsersToAssign = async ({ query }: SearchUserPayload) => {
        const response = await userServiceFetch.filterUsers({ query: `status_ids=1&${query}` })
        const list: UserItem[] = response.map(user => ({
            id: user.id.toString(),
            fullName: user.fullName,
            role: user.role
        }))
        dispatch({ type: LogbookActionEnum.SEARCH_USERS, payload: { value: list } })
    }

    const datesItems = () => {
        setItems(prev => ({ ...prev, year: getPreviousYears(), month: monthYear.map(item => ({ ...item, value: item.value + 1 })), }))
    }
    const selectUser = (payload: SelectUserPayload) => {
        dispatch({ type: LogbookActionEnum.SELECT_USER_TO_ASSIGN, payload })
    }

    const getActivities = async ({ ids, myActivity, onlyUser, query }: ActivitiesByIdsPayload) => {
        const response = await loogbookServiceFetch.listOfActiviesOfId({ query: `${myActivity ? '' : `ids_user=${ids.join(',')}`}${query ? `&${query}` : ''}`, onlyUser, myActivity })

        if (myActivity) {
            dispatch({ type: LogbookActionEnum.SAVE_USER_ACTIVITIES_MARK, payload: { value: response.transform.userMark, myActivity, totalPage: response.total } })
        }
        loadingActivities(false)
        return response
    }

    const getDestinations = async ({ query }: { query: string }) => {
        const response = await loogbookServiceFetch.listOfDestinations({ query: `${query ? `&${query}` : ''}` })
        return response
    }

    const getMyTypes = async ({ id, query }: { id: string, query: string }) => {
        const response = await loogbookServiceFetch.listOfMyTypes({ query, id })
        return response
    }

    const getDetailInform = async ({ query, uuidTab }: DetailInformPayload) => {
        const response = await loogbookServiceFetch.getDetailInform({ uuid: state.uuid[uuidTab], query })
        if (!(response.code == '02')) {
            dispatch({ type: LogbookActionEnum.EDIT_ERROR, payload: { error: false, uuidType: uuidTab } })
            if (!state.uuid[uuidTab]) {
                dispatch({ type: LogbookActionEnum.EDIT_UUID, payload: { uuid: response.uuid, uuidType: uuidTab } })
                dispatch({ type: LogbookActionEnum.LOAD_STATE, payload: { load: true, loadType: uuidTab } })
            } else {
                const url = (response as UrlDetasilInbform).reportUrl ?? '';
                if (url) {
                    const response = await fetch(url);
                    if (!response.ok) { throw new Error(`Error al descargar el archivo: ${response.statusText}`); }
                    const blob = await response.blob();
                    const zipBlob = new Blob([blob], { type: 'application/zip' });
                    downloadBlob(zipBlob, 'Informe resumen');
                    dispatch({ type: LogbookActionEnum.EDIT_UUID, payload: { uuid: undefined, uuidType: uuidTab } })
                    dispatch({ type: LogbookActionEnum.LOAD_STATE, payload: { load: false, loadType: uuidTab } })
                }
            }
        } else {
            dispatch({ type: LogbookActionEnum.EDIT_ERROR, payload: { error: true, uuidType: uuidTab } })
            dispatch({ type: LogbookActionEnum.LOAD_STATE, payload: { load: false, loadType: uuidTab } })
        }
    }

    const getReportDestination = async ({ query, type }: { query: string, type: string }) => {
        const response = await loogbookServiceFetch.getReportDestination({ query, type })
        if (!response.errors) {
            dispatch({ type: LogbookActionEnum.EDIT_UUID, payload: { uuid: response.uuid, uuidType: UserSection.DESTINATION } })
            dispatch({ type: LogbookActionEnum.LOAD_STATE, payload: { load: true, loadType: UserSection.DESTINATION } })

        }
    }

    const getByUuidDestination = async ({ uuid }: { uuid: string }) => {
        const response = await loogbookServiceFetch.getByUuidDestination({ uuid })
        if (response.reportUrl) {
            const url = (response as UrlDetasilInbform).reportUrl ?? '';
            if (url) {
                const path = url.split("?")[0];
                const parts = path.split(".");
                const extension = parts[parts.length - 1];
                const response = await fetch(url);
                if (!response.ok) { throw new Error(`Error al descargar el archivo: ${response.statusText}`); }
                const blob = await response.blob();
                downloadBlob(blob, `Destinos.${extension}`);
                dispatch({ type: LogbookActionEnum.EDIT_UUID, payload: { uuid: undefined, uuidType: UserSection.DESTINATION } })
                dispatch({ type: LogbookActionEnum.LOAD_STATE, payload: { load: false, loadType: UserSection.DESTINATION } })
            }
        }
    }

    const change = ({ uuidTab }: DetailInformPayload) => {
        dispatch({ type: LogbookActionEnum.EDIT_ERROR, payload: { error: false, uuidType: uuidTab } })
    }

    const deleteActivity = async ({ id }: { id: string }) => {
        const response = await loogbookServiceFetch.deleteActivities(id)
        return response
    }

    const deleteDestination = async ({ id }: { id: number }) => {
        const response = await loogbookServiceFetch.deleteDestination(id)
        return response
    }

    const updateDestination = async ({ id, body }: { body: ObjectGeneric, id: number }) => {
        const response = await loogbookServiceFetch.updateDestination(body, id)
        return response
    }

    const convertInUnity = async ({ id, body }: { body: ObjectGeneric, id: number }) => {
        const response = await loogbookServiceFetch.convertToUnity(body, id)
        return response
    }

    const loadingUserList = (value: boolean = true) => {
        dispatch({ type: LogbookActionEnum.LOADINGS, payload: { name: LogbookLoadings.USER_LIST, value } })
    }
    const loadingActivities = (value: boolean = true) => {
        dispatch({ type: LogbookActionEnum.LOADINGS, payload: { name: LogbookLoadings.GET_ACTIVITIES, value } })
    }
    const usersMarkList = async ({ query }: UserMapListPayload) => {
        const response = await loogbookServiceFetch.usersActivities({ query: `view=users&${query}` })
        dispatch({
            type: LogbookActionEnum.SAVE_USER_LIST_MAP, payload: {
                userList: response.transform.userList,
                usersMark: response.transform.userMark || [],
                totalPage: response.total ?? 0
            }
        })
        loadingUserList(false)
        return { users: response.transform.users }
    }
    const checkUser = ({ ids, all }: { ids: string[]; all?: boolean }) => {
        dispatch({ type: LogbookActionEnum.CHECK_USER, payload: { ids, all } })
    }
    useEffect(() => {
        const newRole = getUserRole();
        const newTab = newRole == Roles.PARTNER ? TabsItem.MY_ACTIVITY : TabsItem.ACTIVITY_REGISTER;

        if (state.tab !== newTab) {
            dispatch({ type: LogbookActionEnum.CHANGE_TAB, payload: { value: newTab } });
        }
    }, [getUserRole]);

    return (
        <LogbookContext.Provider value={{
            listTab,
            changeTab,
            checkUser,
            state,
            items,
            loadingUserList,
            selectUser,
            changeActivitySection,
            selectUserToActivities,
            loadingActivities,
            filter: {
                filterListUser,
                filterOneUser,
                filterUser,
                filterMyActivity,
                filterDestinations,
            },
            service: {
                getAreaItem,
                searchUsersToAssign,
                getUsersItem,
                getDepartmentItem,
                usersMarkList,
                getStatusItem,
                getDetailInform,
                getStoreItem,
                change,
                getActivities,
                getDestinations,
                getMyTypes,
                datesItems,
                getDivisionItem,
                getRoleItem,
                getUserTypeItem,
                deleteActivity,
                deleteDestination,
                updateDestination,
                convertInUnity,
                getReportDestination,
                getByUuidDestination
            },
            visibleUsersData, // Añadir el estado aquí
            setVisibleUsersData,
            visibleUsersDataGeneralList,
            setVisibleUsersDataGeneralList,
            visibleUsersDataByUser,
            setVisibleUsersDataByUser,
            hiddenLocalConstant,
            setHiddenLocalConstant
        }}>
            {children}
        </LogbookContext.Provider>
    )
}